import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
// // 检测设备类型并返回类型或 false
// function getDeviceType() {
//   const userAgent = navigator.userAgent;
//   if (/Windows/i.test(userAgent)) {
//     return "Windows";
//   }
//   return false; // 如果不是移动设备，返回 false
// }
// // 将设备类型或 false 注入全局属性
// app.config.globalProperties.$isPC = getDeviceType();
// 检测窗口宽度并返回是否为 PC

// function isPC() {
//   return window.innerWidth > 768;
// }
//
// // 将是否为 PC 注入全局属性
// app.config.globalProperties.$isPC = isPC();
//
// // 监听窗口大小变化并更新全局属性
// window.addEventListener("resize", () => {
//   console.log(window.innerWidth);
//   app.config.globalProperties.$isPC = isPC();
// });

// 创建一个全局的 mixin 来处理 isPC
app.mixin({
  data() {
    return {
      isPC: window.innerWidth > 768, // 初始判断
    };
  },
  mounted() {
    window.addEventListener("resize", this.updateIsPC);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateIsPC);
  },
  methods: {
    updateIsPC() {
      this.isPC = window.innerWidth > 768; // 更新 isPC
    },
  },
});

app.use(ElementPlus, { locale: zhCn });
app.use(store).use(router).use(pinia).mount("#app");
